
export interface Country {
  code: string;
  name: string;
  currency: string;
  flag: string;
  minimumAmount: number;
  paystackPublicKey: string;
}

export const SUPPORTED_COUNTRIES: Country[] = [
  {
    code: 'KE',
    name: 'Kenya',
    currency: 'KES',
    flag: '🇰🇪',
    minimumAmount: 2500,
    paystackPublicKey: 'pk_live_06eee82afad74289ba2777528984f75f0f40ee51'
  }
];

export const REPAYMENT_PERIODS = [
  { months: 6, label: '6 months' },
  { months: 12, label: '12 months' },
  { months: 24, label: '24 months' },
  { months: 36, label: '36 months' },
  { months: 60, label: '60 months' }
];

export const INVESTMENT_PLANS = [
  {
    id: 1,
    amount: 50000,
    returns: 100000,
    duration: '24 hours',
    durationDays: 1,
    roi: '100%'
  },
  {
    id: 2,
    amount: 100000,
    returns: 200000,
    duration: '2 days',
    durationDays: 2,
    roi: '100%'
  },
  {
    id: 3,
    amount: 200000,
    returns: 400000,
    duration: '4 days',
    durationDays: 4,
    roi: '100%'
  },
  {
    id: 4,
    amount: 500000,
    returns: 1000000,
    duration: '1 week',
    durationDays: 7,
    roi: '100%'
  },
  {
    id: 5,
    amount: 1000000,
    returns: 2000000,
    duration: '2 weeks',
    durationDays: 14,
    roi: '100%'
  }
];

export const calculateMinimumInvestment = (currencyCode: string): number => {
  return 2500;
};

export const formatCurrency = (amount: number, currencyCode: string): string => {
  return `KSh ${amount.toLocaleString()}`;
};

export const getCurrencySymbol = (currencyCode: string): string => {
  return 'KSh';
};

export const getPaystackPublicKey = (countryCode: string): string => {
  return 'pk_live_06eee82afad74289ba2777528984f75f0f40ee51';
};
